"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = void 0;
const qs_1 = __importDefault(require("qs"));
const prefix = "__config__";
class Configuration {
    constructor(config, env, storage, search = "") {
        this.config = config;
        this.storage = storage;
        this.search = search;
        let value = this.getParam(this.getKey("env"));
        if (value === undefined) {
            value = storage.getItem(this.getKey("env")) || undefined;
            if (value === undefined) {
                value = env;
            }
        }
        this.env = value || "";
        console.log("env", this.env);
    }
    extract(key) {
        let value = this.getParam(this.getKey(key));
        if (value === undefined) {
            value = this.storage.getItem(this.getKey(key)) || undefined;
            if (value === undefined) {
                value = this.config[key];
                if (typeof value === "object") {
                    value = value[this.env];
                }
            }
        }
        return value ?? "";
    }
    getKey(key) {
        return prefix + key;
    }
    getParam(key) {
        let search = this.search;
        if (search.startsWith("?"))
            search = search.substring(1);
        const params = qs_1.default.parse(this.search);
        return params[key]?.toString();
    }
}
exports.Configuration = Configuration;
